import { create } from "zustand";

export const useSelectedPathStore = create((set: any) => ({
  selectedpath: [],
  setSelectedPath: (error: any) => set({ selectedpath: error }),
}));
